// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"B2-z"};